import React, { useEffect, useRef, useState } from 'react';

const prefiereMenosMovimiento = () =>
  typeof window !== 'undefined' &&
  window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const formatoEntero = (n) => Math.round(n).toLocaleString('es-MX');

// Anima el número desde su valor anterior hasta `value` (cuenta ascendente suave).
const AnimatedNumber = ({ value = 0, format = formatoEntero, duration = 900 }) => {
  const [display, setDisplay] = useState(0);
  const desdeRef = useRef(0);

  useEffect(() => {
    const destino = Number(value) || 0;

    if (prefiereMenosMovimiento()) {
      desdeRef.current = destino;
      setDisplay(destino);
      return undefined;
    }

    const desde = desdeRef.current;
    const inicio = performance.now();
    let frame;

    const paso = (ahora) => {
      const t = Math.min(1, (ahora - inicio) / duration);
      const suavizado = 1 - Math.pow(1 - t, 3);
      const actual = desde + (destino - desde) * suavizado;
      desdeRef.current = actual;
      setDisplay(actual);
      if (t < 1) frame = requestAnimationFrame(paso);
    };

    frame = requestAnimationFrame(paso);
    return () => cancelAnimationFrame(frame);
  }, [value, duration]);

  return <>{format(display)}</>;
};

export default AnimatedNumber;
